import axios from "axios"

const instance = axios.create({
  baseURL: 'https://person.clearbit.com/v2/combined/find?email=',
  headers: {
    'Authorization': 'Bearer ' + "sk_a8197f635c8a13171a9a7bee159cc819"
  }
});

export default instance 